const SAVE_FOR_LATER_LIST_TYPE = 'save_for_later';
const DEFAULT_SHOPPING_LIST_NAME = 'save_for_later List'; // Fallback for API shoppingListName param
const SAVE_FOR_LATER_MAX_ITEMS = 100;
const SAVE_FOR_LATER_CAROUSEL_MAX_ITEMS = 10;

const ACTION_TYPES = {
    SET_SAVE_FOR_LATER_LOADING: 'SET_SAVE_FOR_LATER_LOADING',
    SET_SAVE_FOR_LATER_ERROR: 'SET_SAVE_FOR_LATER_ERROR',
    UPDATE_SAVE_FOR_LATER_LISTS: 'UPDATE_SAVE_FOR_LATER_LISTS',
    UPDATE_SAVE_FOR_LATER_ITEMS: 'UPDATE_SAVE_FOR_LATER_ITEMS',
    ADD_SAVE_FOR_LATER_ITEM_OPTIMISTIC: 'ADD_SAVE_FOR_LATER_ITEM_OPTIMISTIC',
    REMOVE_SAVE_FOR_LATER_ITEM_OPTIMISTIC: 'REMOVE_SAVE_FOR_LATER_ITEM_OPTIMISTIC',
    SET_MOVING_SKU: 'SET_MOVING_SKU',
    REMOVE_MOVING_SKU: 'REMOVE_MOVING_SKU',
    CLEAR_MOVING_SKUS: 'CLEAR_MOVING_SKUS',
    SET_SAVE_FOR_LATER_CONFIRMATION: 'SET_SAVE_FOR_LATER_CONFIRMATION',
    CLEAR_SAVE_FOR_LATER_CONFIRMATION: 'CLEAR_SAVE_FOR_LATER_CONFIRMATION',
    SET_BASKET_CONFIRMATION: 'SET_BASKET_CONFIRMATION',
    CLEAR_BASKET_CONFIRMATION: 'CLEAR_BASKET_CONFIRMATION'
};

export {
    SAVE_FOR_LATER_LIST_TYPE, DEFAULT_SHOPPING_LIST_NAME, SAVE_FOR_LATER_MAX_ITEMS, SAVE_FOR_LATER_CAROUSEL_MAX_ITEMS, ACTION_TYPES
};
